import React from 'react';
import CustomPagination from '../CustomPagination.jsx';

const EmployeeTabPagination = ({ page, totalPages, onPageChange }) =>
  totalPages > 1 ? (
    <div className="flex flex-end component component-md component-bg-white">
      <CustomPagination
        totalPages={totalPages}
        currentPage={page}
        action={onPageChange}
      />
    </div>
  ) : null;

export default EmployeeTabPagination;
